module.exports = __webpack_public_path__ + "img/PW.c5a4b0fe.svg";